import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import AuthLayout from '@/components/AuthLayout';
import { authApi } from '@/features/auth/auth.api';
import { extractError } from '@/lib/axios';

export default function VerifyEmailPage(): JSX.Element {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [state, setState] = useState<'loading' | 'ok' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) {
      setState('error');
      setMessage('Missing verification token.');
      return;
    }
    authApi
      .verifyEmail(token)
      .then(() => setState('ok'))
      .catch((err) => {
        setState('error');
        setMessage(extractError(err).message);
      });
  }, [token]);

  return (
    <AuthLayout title="Email verification">
      {state === 'loading' && <p className="text-sm text-slate-500">Verifying…</p>}
      {state === 'ok' && (
        <>
          <p className="text-sm text-green-600">Your email is verified. You can now log in.</p>
          <Link to="/login" className="btn-primary mt-4">
            Go to login
          </Link>
        </>
      )}
      {state === 'error' && (
        <>
          <p className="text-sm text-red-600">{message}</p>
          <Link to="/login" className="btn-ghost mt-4">
            Back to login
          </Link>
        </>
      )}
    </AuthLayout>
  );
}
